import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import ProtectedRoute from "./routes/ProtectedRoute";

import Authentication from "./pages/Authentication/Authentication";
import WhatsAppFab from "./components/WhatsAppFab/WhatsAppFab";
import Profile from "./pages/Profile/Profile";
import AdminSupportChats from "./pages/SupportChats/SupportChats";
import AffiliationPage from "./pages/Affiliation/Affiliation";
import CartPage from "./pages/Cart/Cart";
import Home from "./pages/home/home";
import Offers from "./pages/Offers/Offers";
import FAQPage from "./pages/faq/FAQ";
import ContactPage from "./pages/contact/contact";
import TermsPage from "./pages/Static/TermsPage";
import PrivacyPage from "./pages/Static/PrivacyPage";
import SupportChats from "./pages/SupportChats/SupportChats";

import PartnerOffer from "./pages/PartnerOffers/PartnerOffers";
import ConfigPage from "./pages/ConfigPage/ConfigPage";
import AdminUsers from "./pages/AdminPages/AdminUsers";
import AdminTransactions from "./pages/AdminPages/AdminTransactions";
import AdminNotifications from "./pages/AdminPages/AdminNotifications";
import AdminPromocodes from "./pages/AdminPages/AdminPromocodes";
import AdminCarriers from "./pages/AdminPages/AdminCarriers";
import AdminWallets from "./pages/AdminPages/AdminWallets";
import AdminRoles from "./pages/AdminPages/AdminRoles";

import NavigationHeader from "./components/Elements/Header/Header";
import EsimScreen from "./pages/Esim/Esim";
import EsimStats from "./pages/EsimStats/EsimStats";
import Login from "./pages/Authentication/Authentication";
import Register from "./pages/Authentication/Register";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import Footer from "./components/Elements/Footer/Footer";
import { initGA, logPageView } from "./analytics/analytics";
import AnalyticsTracker from "./analytics/AnalyticsTracker";

function App() {
  useEffect(() => {
    initGA();
  }, []);
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <AuthProvider>
        <div className="main-container">
          <CartProvider>
            <NavigationHeader />
            <Routes>
              <Route path="/sign-in" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              <Route path="/shop" element={<Offers />} />
              <Route
                path="/esim"
                element={
                  <ProtectedRoute>
                    <EsimScreen />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<Home />} />

              <Route path="/cart" element={<CartPage />} />
              <Route path="/faq" element={<FAQPage />} />

              <Route path="/contact" element={<ContactPage />} />

              <Route path="/terms" element={<TermsPage />} />

              <Route
                path="/affiliation"
                element={
                  <ProtectedRoute>
                    <AffiliationPage />
                  </ProtectedRoute>
                }
              />

              <Route path="/privacy-policy" element={<PrivacyPage />} />

              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/partner-offer"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <PartnerOffer />
                  </ProtectedRoute>
                }
              />

              <Route
                path="config"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <ConfigPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/users"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminUsers />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/transactions"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminTransactions />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/wallets"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminWallets />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/carriers"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminCarriers />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/roles"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminRoles />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/promocodes"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminPromocodes />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/notifications"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminNotifications />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/support-chats"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminSupportChats />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/esim"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <EsimStats />
                  </ProtectedRoute>
                }
              />

              {/* <Route
              path="/admin/users"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/stats/:type"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminStats />
                </ProtectedRoute>
              }
            /> */}

              <Route path="/" element={<Navigate to="/shop" replace />} />
            </Routes>
            <WhatsAppFab />
          </CartProvider>
        </div>
      </AuthProvider>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
